export default __webpack_public_path__ + "static/media/AngsanaNew.3779c484.eot";